export const languages = [
  {
    label: 'Swedish',
    value: 'sv',
  },
  {
    label: 'Danish',
    value: 'da',
  },
  {
    label: 'Finnish',
    value: 'fi',
  },
  {
    label: 'Norwegian',
    value: 'no',
  },
  {
    label: 'Icelandic',
    value: 'is',
  },
];
